import {useAccountSelectorPersonalEntityUserQuery} from '../../../generated/graphql';
import {NetworkStatus} from '../../../state/graphql/apolloWithAbort';

type UseLegacyPersonalEntityOwnerParams = {
  entityName: string | null | undefined;
  shouldLoad: boolean;
};

export function useLegacyPersonalEntityOwner({
  entityName,
  shouldLoad,
}: UseLegacyPersonalEntityOwnerParams) {
  const skip = !shouldLoad || !entityName;
  const {data, networkStatus} = useAccountSelectorPersonalEntityUserQuery({
    variables: {teamName: entityName ?? ''},
    skip,
  });

  return {
    ownerID: data?.entity?.user?.id,
    // A failed lookup must not leave the account selector stuck loading, so
    // treat the error status as finished.
    isLoading:
      !skip &&
      networkStatus !== NetworkStatus.ready &&
      networkStatus !== NetworkStatus.error,
  };
}
